import { IApplicationState, TBoardId, TColorId } from '../../../../types/types';
import { getBoardCardColorTags } from '../../selectors/getBoardCardColorTags';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';

export const getBoardUserMetaRecentColorTags = (
    state: IApplicationState,
    boardId: TBoardId,
): TColorId[] => {
    const userBoardMeta= getBoardUserMeta(state, boardId);
    const boardCardColorsTagIds = getBoardCardColorTags(state, boardId).map(colorTag => colorTag.id);
    return (userBoardMeta && userBoardMeta.recentColorTags || [])
        .filter(colorTagId => boardCardColorsTagIds.includes(colorTagId)); // проверяем, есть ли такие колортеги
};
